import {skipToken} from '@reduxjs/toolkit/query';

import {isNil} from 'ramda';

import {useGetFileByIdQuery} from '@dms/api/base';
import type {ImageAssetRef} from '@dms/api/new-vehicle';

import type {Nullish} from 'shared/web';

/** Without a fileId the asset reference is a legacy external URL. */
export function useCatalogueImageUrl(imageAssetRef: ImageAssetRef | Nullish) {
  const fileId = imageAssetRef?.fileId;
  const {currentData: file, isFetching} = useGetFileByIdQuery(isNil(fileId) ? skipToken : {fileId});
  return {
    url: isNil(fileId) ? (imageAssetRef?.assetReference ?? null) : (file?.originalUri ?? null),
    isLoading: isFetching && isNil(file),
  };
}
